import { Output } from '@angular/core';
import { EventEmitter, Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-voce-menu',
  templateUrl: './menu-voce-menu.component.html',
  styles: []
})
export class MenuVoceMenuComponent {

  constructor() { }

  @Input() voce;
  @Input()
  set isSecondoLivelloDesktop(isSecondoLivelloDesktop) {
    if (isSecondoLivelloDesktop) {
      this.classes = 'dropdown-item pointer dropdown-secondo-livello';
      if (this.voce && this.voce.figli && this.voce.figli.length > 0) {
        this.classes += ' dropdown-toggle';
      }
    }
  }

  classes = '';



}
